/*
 * @Author: Nie Wie
 * @Date: 2020-03-25 10:48:58
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-04-02 14:07:34
 * @Description: 简报路由
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: '',
      path: '/',
      redirect: '/observe',
    },
    {
      name: 'Observe',
      path: '/observe',
      component: () => import('@/views/observe'),
    },
    // 产品
    {
      name: 'Work',
      path: '/work',
      component: () => import('@/views/work'),
    },
    // 解决方案
    {
      name: 'Season',
      path: '/season',
      component: () => import('@/views/season'),
    },
  ],
})
